module.exports = __webpack_public_path__ + "static/img/sportGame1.371e611.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/sportGame1.png
// module id = vAY9
// module chunks = 3